import { YieldFetcher } from '../../types'

const YIELDNEST_URL = 'https://gateway.yieldnest.finance/api/v1/graphql'

const YIELDNEST_GQL_QUERY =
  'query GetTokenMetrics($networkType: NetworkType!) { getLRTsData(networkType: $networkType) { tokens { token blockchains { chainId apr { apr31d } } } } }'

/** YieldNest token symbol → { chainId, assetGroup key } */
const YN_TOKENS: {
  symbol: string
  chainId: number
  key: string
}[] = [
  { symbol: 'ynETHx', chainId: 1, key: 'ynETH MAX::YNETHX' },
  { symbol: 'ynETH', chainId: 1, key: 'YieldNest Restaked ETH::YNETH' },
  {
    symbol: 'ynLSDe',
    chainId: 1,
    key: 'YieldNest Restaked LSD Eigenlayer::YNLSDE',
  },
  { symbol: 'ynRWAx', chainId: 1, key: 'YieldNest RWA MAX::YNRWAX' },
  { symbol: 'ynUSDx', chainId: 1, key: 'ynUSD Max::YNUSDX' },
  { symbol: 'STAK', chainId: 1, key: 'YieldNest STAK::STAK' },
  { symbol: 'ynBNBx', chainId: 56, key: 'ynBNB MAX::ynBNBx' },
  { symbol: 'ynBNB', chainId: 56, key: 'YieldNest Restaked BNB::ynBNB' },
  { symbol: 'ynBTCk', chainId: 56, key: 'YieldNest BTC Kernel::ynBTCk' },
]

/** Look up apr31d for a given token symbol + chainId from the API response */
function findApr(tokens: any[], symbol: string, chainId: number): number {
  const apr = tokens
    .find((t: any) => t.token === symbol)
    ?.blockchains?.find((b: any) => b.chainId === chainId)?.apr?.apr31d
  return Number(apr ?? 0)
}

export const yieldNestFetcher: YieldFetcher = {
  label: 'YIELDNEST',
  fetch: async () => {
    const res = await fetch(YIELDNEST_URL, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        operationName: 'GetTokenMetrics',
        variables: { networkType: 'mainnet' },
        query: YIELDNEST_GQL_QUERY,
      }),
    }).then((r) => r.json())

    const tokens = res?.data?.getLRTsData?.tokens ?? []

    const result: Record<string, number> = {}
    for (const { symbol, chainId, key } of YN_TOKENS) {
      const apr = findApr(tokens, symbol, chainId)
      if (apr > 0) result[key] = apr
    }
    return result
  },
}
